import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left"
import { GenericBoxWithLabels } from "../../tools/components/genericBoxWithLabels"
import Button from "../../../ui/molecules/button"
import { useState } from "react"
import { Alert } from "../../../ui/organisms/alert"
import { M024Delete, setM024UpdateCancelRev, setM024UpdateClose } from "./slice"

export function EditM024() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const [showAlertDelete, setShowAlertDelete] = useState<boolean>(false)
    const [showAlertUndo, setShowAlertUndo] = useState<boolean>(false)
    const [showAlertClose, setShowAlertClose] = useState<boolean>(false)
    const [showAlertRetry, setShowAlertRetry] = useState<boolean>(false)


    const M024Response =
    {
        id: '1',
        creationDate: '20/02/2025',
        evaluationDate: '20/02/2025',
        evaluationOfficer: 'Luigi Ras',
        reviewOfficer: ['Sandro Mas', 'Cinzia Cenz', 'Giorgio Rosso'],
        reviewDate: '25/02/2025',
        closed: false
    }

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Dettaglio M024']}
            noPaddingLat
            headerLabel="VALUTAZIONE, RIESAME E DELIBERA DEL PROCESSO DI CONTROLLO E DI CERTIFICAZIONE"
            headerIcon={
                <button style={{ paddingTop: '12px' }} onClick={() => {
                    navigate('/listM024')
                }}>
                    <ArrowLeftIcon />
                </button>
            }

        >
            <div style={{ padding: '12px 24px 0px 24px' }}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }} className="mt-10">
                    <div style={{ flex: '0.5' }} >
                        <GenericBoxWithLabels
                            title="Valutazione"
                            description={'Data Valutazione ' + 'data'}
                            description2="Funzionario Valutazione"
                            label1={M024Response.evaluationDate}
                            label2={M024Response.evaluationOfficer}
                            onClick={() => navigate('/editValutazioneM024')}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <GenericBoxWithLabels
                            title="Riesame"
                            description={'Data Valutazione ' + 'data'}
                            description2="Funzionario Valutazione"
                            label1={'15/05/2025'}
                            label2={'Fabio Scionti'}
                            onClick={() => navigate('/editRiesameM024')}
                        />
                    </div>
                </div>
                <div className="mt-10" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1' }}>
                        <GenericBoxWithLabels
                            title="Decisione"
                            description={'Data Valutazione ' + 'data'}
                            description2="Funzionario Valutazione"
                            label1={'15/05/2025'}
                            label2={'Fabio Scionti'}
                            onClick={() => navigate('/editDecisioneM024')}
                        />
                    </div>
                </div>

                <div className="flex flex-col mt-12">
                    <span className="sectionTitle mb-4">Strumenti</span>
                    {
                        !M024Response.closed ? (
                            <div className="flex gap-10">
                                <Button
                                    size="sm"
                                    iconPosition="off"
                                    variant="solid"
                                    label="Chiudi M024"
                                    color="dimgrey"
                                    disabled={!sessionState.selected.customerId}
                                    onClick={() => { setShowAlertClose(true) }}
                                />

                                <Button
                                    size="sm"
                                    iconPosition="off"
                                    variant="solid"
                                    label="Annulla Revisione"
                                    color="dimgrey"
                                    disabled={!sessionState.selected.customerId}
                                    onClick={() => { setShowAlertUndo(true) }}
                                />

                                <Button
                                    size="sm"
                                    iconPosition="off"
                                    variant="solid"
                                    label="Cancella Revisione"
                                    color="red"
                                    disabled={!sessionState.selected.customerId}
                                    onClick={() => { setShowAlertDelete(true) }}
                                />
                            </div>
                        ) : (
                            <div>
                                Nessun Strumento <span onClick={() => { setShowAlertRetry(true) }}>disponibile</span>
                            </div>
                        )
                    }

                </div>

                {
                    (showAlertDelete) && (
                        <Alert title="Conferma Eliminazione" close={() => setShowAlertDelete(false)} headerGreen={true}>
                            <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="pb-3 mt-6">
                                    <div>
                                        Sei sicuro di voler <b>eliminare</b> questa revisione?
                                    </div>

                                </div>
                                <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Button
                                        variant="outline"
                                        color="dimgrey"
                                        iconPosition="off"
                                        label="Annulla"
                                        size="md"
                                        onClick={() => setShowAlertDelete(false)}
                                    />
                                    <div className="pl-8">
                                        <Button
                                            variant="solid"
                                            color="orange"
                                            iconPosition="off"
                                            label="Elimina"
                                            size="md"
                                            onClick={() => dispatch(M024Delete('1'))}
                                        />
                                    </div>
                                </div>

                            </div>
                        </Alert>
                    )
                }

                {
                    (showAlertUndo) && (
                        <Alert title="Conferma Annullamento" close={() => setShowAlertUndo(false)} headerGreen={true}>
                            <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="pb-3 mt-6">
                                    <div>
                                        Sei sicuro di voler <b>annullare</b> questa revisione?
                                    </div>

                                </div>
                                <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Button
                                        variant="outline"
                                        color="dimgrey"
                                        iconPosition="off"
                                        label="Annulla"
                                        size="md"
                                        onClick={() => setShowAlertUndo(false)}
                                    />
                                    <div className="pl-8">
                                        <Button
                                            variant="solid"
                                            color="orange"
                                            iconPosition="off"
                                            label="Elimina"
                                            size="md"
                                            onClick={() => {
                                                dispatch(setM024UpdateCancelRev(true))
                                            }
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </Alert>
                    )
                }

                {
                    (showAlertClose) && (
                        <Alert title="Conferma Chiusura" close={() => setShowAlertClose(false)} headerGreen={true}>
                            <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="pb-3 mt-6">
                                    <div>
                                        Sei sicuro di voler <b>chiudere</b> questa revisione?
                                    </div>

                                </div>
                                <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Button
                                        variant="outline"
                                        color="dimgrey"
                                        iconPosition="off"
                                        label="Annulla"
                                        size="md"
                                        onClick={() => setShowAlertClose(false)}
                                    />
                                    <div className="pl-8">
                                        <Button
                                            variant="solid"
                                            color="orange"
                                            iconPosition="off"
                                            label="Elimina"
                                            size="md"
                                            onClick={() => dispatch(setM024UpdateClose(true))}
                                        />
                                    </div>
                                </div>

                            </div>
                        </Alert>
                    )
                }
                {
                    (showAlertRetry) && (
                        <Alert title="Conferma Riapertura" close={() => setShowAlertRetry(false)} headerGreen={true}>
                            <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="pb-3 mt-6">
                                    <div>
                                        Sei sicuro di voler <b>riaprire</b> questa revisione?
                                    </div>

                                </div>
                                <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Button
                                        variant="outline"
                                        color="dimgrey"
                                        iconPosition="off"
                                        label="Annulla"
                                        size="md"
                                        onClick={() => setShowAlertRetry(false)}
                                    />
                                    <div className="pl-8">
                                        <Button
                                            variant="solid"
                                            color="green"
                                            iconPosition="off"
                                            label="Riapri"
                                            size="md"
                                            onClick={() =>
                                                dispatch(setM024UpdateClose(false))
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </Alert>
                    )
                }
            </div>
        </Layout>
    )

}